export default function getSafeRedirectUrl(rawRedirectUrl) {
  if (!rawRedirectUrl) return null;

  try {
    const parsed = new URL(rawRedirectUrl, window.location.origin);

    if (parsed.origin !== window.location.origin) {
      console.warn('Ignoring cross-origin redirectUrl:', rawRedirectUrl);
      return null;
    }

    // Return path-only for extra safety
    return parsed.pathname + parsed.search + parsed.hash;
  } catch (e) {
    console.warn('Ignoring invalid redirectUrl:', rawRedirectUrl);
    return null;
  }
}